export default {"src":"/_next/static/media/thunderstorm.35edfd0b.svg","height":45,"width":50,"blurWidth":0,"blurHeight":0};